<template>
  <div>
    <h1>Manage User Groups</h1>
    <div class="mt-5">
      <manage-user-groups-table :user-groups-list="userGroupsList" :client-index="clientIndex" :client-details="clientDetails" />
    </div>
  </div>
</template>

<script>
import ManageUserGroupsTable from '@/components/manageUserGroups/ManageUserGroupsTable'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'manage-user-groups',
  components: {
    ManageUserGroupsTable
  },
  computed: {
    ...mapState('manageClient', ['clientIndex', 'clientDetails']),
    ...mapState('manageUserGroups', ['userGroupsList'])
  },
  created() {
    this.getUserGroups()
    this.getClientDetails()
  },
  methods: {
    ...mapActions('manageUserGroups', ['getUserGroups']),
    ...mapActions('manageClient', ['getClientDetails'])
  }
}
</script>
